module.exports = __webpack_public_path__ + "static/img/sanwei-1.082914a3.png";